<template>
  <div>
    <v-card height="80vh" class="overflow-hidden">
      <!-- title -->
      <v-card-title>
        <span class="primary--text">{{ fullName }}</span>
        <v-icon
          v-if="showCloseBtn"
          class="ml-auto"
          @click="$emit('close')"
        >
          mdi-close
        </v-icon>
      </v-card-title>
      <!-- details -->
      <v-card-text style="height: 70vh;" class="overflow-auto">
        <v-row>
          <v-col cols="6" class="py-0">
            <!-- case title -->
            <v-row dense>
              <v-col
                cols='12'
                class="d-flex" 
              >
                <span class="d-block">
                  Case Title⁄Health Concern
                </span>
                <span class="ml-auto font-weight-medium">
                  {{ value.health_concern }}
                </span>
              </v-col>
            </v-row>
            <!-- case no -->
            <v-row dense>
              <v-col
                cols='12'
                class="d-flex" 
              >
                <span class="d-block">
                  Case No.
                </span>
                <span class="ml-auto font-weight-medium">
                  {{ value.case_number }}
                </span>
              </v-col>
            </v-row>
            <!-- case id -->
            <v-row dense>
              <v-col
                cols='12'
                class="d-flex" 
              >
                <span class="d-block">
                  Case
                </span>
                <span class="ml-auto font-weight-medium">
                  {{ 'Case #'+ value.id }}
                </span>
              </v-col>
            </v-row>
            <!-- consulations -->
            <v-row dense>
              <v-col
                cols='12'
                class="d-flex" 
              >
                <span class="d-block">
                  Consultations
                </span>
                <span class="ml-auto font-weight-medium">
                  {{ value.consultations.length }} (for this case)
                </span>
              </v-col>
            </v-row>
            <!-- method -->
            <v-row dense>
              <v-col
                cols='12'
                class="d-flex" 
              >
                <span class="d-block">
                  Preferred Call Method
                </span>
                <span class="ml-auto font-weight-medium text-capitalize">
                  {{ value.preferred_method }}
                </span>
              </v-col>
            </v-row>
            <!-- datetime -->
            <v-row dense>
              <v-col
                cols='12'
                class="d-flex" 
              >
                <span class="d-block">
                  Preferred Call Date
                </span>
                <span class="ml-auto font-weight-medium">
                  {{ value.preferred_datetime | moment }}
                </span>
              </v-col>
            </v-row>
            <!-- vip -->
            <v-row dense>
              <v-col
                cols='12'
                class="d-flex" 
              >
                <span class="d-block">
                  VIP
                </span>
                <span class="ml-auto font-weight-medium">
                  {{ value.patient.patient.is_vip ? 'Yes' : 'No' }}
                </span>
              </v-col>
            </v-row>
            <!-- warning -->
            <v-row dense>
              <v-col
                cols='12'
                class="d-flex" 
              >
                <span class="d-block">
                  Warning
                </span>
                <span class="ml-auto font-weight-medium">
                  {{ value.patient.patient.has_warning }}
                </span>
              </v-col>
            </v-row>
            <!-- reason -->
            <v-row dense>
              <v-col
                cols='12'
                class="d-flex" 
              >
                <span class="d-block">
                  Warning Reason
                </span>
                <span class="ml-auto font-weight-medium">
                  {{ value.patient.patient.warning_reason || 'N&frasl;A' }}
                </span>
              </v-col>
            </v-row>
            <!-- status -->
            <v-row dense>
              <v-col
                cols='12'
                class="d-flex" 
              >
                <span class="d-block">
                  Status
                </span>
                <span class="ml-auto font-weight-medium text-capitalize">
                  {{ value.status || 'N&frasl;A' }}
                </span>
              </v-col>
            </v-row>
          </v-col>
          <v-col cols="6" class="py-0">
            <!-- language -->
            <v-row dense>
              <v-col
                cols='12'
                class="d-flex" 
              >
                <span class="d-block">
                  Language
                </span>
                <span class="ml-auto font-weight-medium">
                  {{ value.patient.patient.preferred_langauge || 'N&frasl;A' }}
                </span>
              </v-col>
            </v-row>
            <!-- gender -->
            <v-row dense>
              <v-col
                cols='12'
                class="d-flex" 
              >
                <span class="d-block">
                  Gender
                </span>
                <span class="ml-auto font-weight-medium">
                  {{ value.patient.patient.gender || 'N&frasl;A' }}
                </span>
              </v-col>
            </v-row>
            <!-- birthdate -->
            <v-row dense>
              <v-col
                cols='12'
                class="d-flex" 
              >
                <span class="d-block">
                  Birthdate
                </span>
                <span v-if="value.patient.patient.birthdate" class="ml-auto font-weight-medium">
                  {{ value.patient.patient.birthdate | birthday }}
                </span>
                <span v-else class="ml-auto font-weight-medium">N&frasl;A</span>
              </v-col>
            </v-row>
            <!-- age -->
            <v-row dense>
              <v-col
                cols='12'
                class="d-flex" 
              >
                <span class="d-block">
                  Age
                </span>
                <span v-if="value.patient.patient.age" class="ml-auto font-weight-medium">
                  {{ value.patient.patient.age }} years old
                </span>
                <span v-else class="ml-auto font-weight-medium">N&frasl;A</span>
              </v-col>
            </v-row>
            <!-- status -->
            <v-row dense>
              <v-col
                cols='12'
                class="d-flex" 
              >
                <span class="d-block">
                  Marital Status
                </span>
                <span class="ml-auto font-weight-medium">
                  {{ value.patient.patient.marital_status || 'N&frasl;A' }}
                </span>
              </v-col>
            </v-row>
            <!-- email -->
            <v-row dense>
              <v-col
                cols='12'
                class="d-flex" 
              >
                <span class="d-block">
                  Email
                </span>
                <span class="ml-auto font-weight-medium">
                  {{ value.patient.email }}
                </span>
              </v-col>
            </v-row>
            <!-- number -->
            <v-row dense>
              <v-col
                cols='12'
                class="d-flex" 
              >
                <span class="d-block">
                  Mobile No.
                </span>
                <span class="ml-auto font-weight-medium">
                  {{ value.patient.patient.mobile_number ? `+63 ${value.patient.patient.mobile_number}` : 'N&frasl;A' }}
                </span>
              </v-col>
            </v-row>
            <!-- company -->
            <v-row dense>
              <v-col
                cols='12'
                class="d-flex" 
              >
                <span class="d-block">
                  Company
                </span>
                <span class="ml-auto font-weight-medium">
                  N&frasl;A
                </span>
              </v-col>
            </v-row>
            <!-- provider -->
            <v-row dense>
              <v-col
                cols='12'
                class="d-flex" 
              >
                <span class="d-block">
                  Insurance Provider
                </span>
                <span class="ml-auto font-weight-medium">
                  {{ value.patient.patient.insurance_provider || 'N&frasl;A' }}
                </span>
              </v-col>
            </v-row>
            <!-- insurance number -->
            <v-row dense>
              <v-col
                cols='12'
                class="d-flex" 
              >
                <span class="d-block">
                  Insurance No.
                </span>
                <span class="ml-auto font-weight-medium">
                  {{ value.patient.patient.insurance_number || 'N&frasl;A' }}
                </span>
              </v-col>
            </v-row>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12">
            <h3>Health Information</h3>
          </v-col>
          <v-col cols="6" class="pt-0">
            <!-- column 1 -->
            <v-row
              dense
              v-for="key in health.keyMap1"
              :key="key"
            >
              <v-col
                cols='12'
                class="d-flex"
              >
                <span class="d-block">
                  {{ key.text }}
                </span>
                <span class="ml-auto font-weight-medium">
                  {{ getDeepProperty(key.key) || 'N&frasl;A' }}
                </span>
              </v-col>
            </v-row>
          </v-col>
          <v-col cols="6" class="pt-0">
            <!-- column 2 -->
            <v-row
              dense
              v-for="key in health.keyMap2"
              :key="key"
            >
              <v-col
                cols='12'
                class="d-flex" 
              >
                <span class="d-block">
                  {{ key.text }}
                </span>
                <span class="ml-auto font-weight-medium">
                  {{ getDeepProperty(key.key) || 'N&frasl;A' }}
                </span>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
  import moment from 'moment'
  import { get } from 'lodash'
  
  export default {
    name: 'SidebarCaseInformation',

    props: {
      value: { 
        type: Object
      },
      showCloseBtn: {
        type: Boolean, 
        default: false 
      }
    },

    data: () => ({
      health: {
        keyMap1: [
          {text: 'Relevant Social Factors', key: 'social_factors', type: ''},
          {text: 'Illness⁄Injury', key: 'illness_injury', type: ''},
          {text: 'Dietary Status', key: 'dietary_status', type: ''},
          {text: 'Immunization', key: 'immunizations', type: ''},
          {text: 'Hospitalization', key: 'hospitalizations', type: ''},
          {text: 'Operation', key: 'operations', type: ''}
        ],
        keyMap2: [
          {text: 'Smoking Habit', key: 'smoking_habit', section: '', type: 'string'},
          {text: 'Alcohol Habit', key: 'alcohol_habit', section: '', type: 'string'},
          {text: 'Blood Type', key: 'blood_type', section: '', type: 'string'},
          {text: 'Period Last Started', key: 'period_last_start', section: '', type: 'string'},
          {text: 'Period Length', key: 'period_length', section: '', type: 'string'},
          {text: 'Period Typical Cycle', key: 'period_typical_cycle', section: '', type: 'string'},
          {text: 'Medications', key: 'current_medication', section: '', type: 'array'},
          {text: 'Chronic Diseases', key: 'chronic_diseases', section: '', type: 'array'}
        ]
      }
    }),

    computed: {
      fullName() {
        var name = '';
        if (this.value.patient.patient.full_name) {
          name = this.value.patient.patient.full_name
        }
        else {
          if (this.value.patient.patient.first_name || this.value.patient.patient.last_name) {
            name = `${this.value.patient.patient.first_name} ${this.value.patient.patient.last_name}`;
          }
          else {
            name = this.value.patient.email
          }
        }
        return name;
      }
    },

    filters: {
      moment: function (date) {
        return moment(date).format('MMM. D, YYYY, h:mmA');
      },
      birthday: function (date) {
        return moment(date).format('MMMM D, YYYY');
      }
    },

    mounted() {
      //
    },

    methods: {
      getDeepProperty(property) {
        return get(this.value.patient.patient, property)
      },
    }
  }
</script>

<style lang="scss" scoped>

</style>